import {IColumnItem} from "@ui/tableCustom/types/columns";


export const styleColumnCb = <T>(column: IColumnItem<T>,): string => {

    if (column?.exportStyles?.pdf) {
        return column['id'] as string;
    }
    return 'tableBodyOdd'
}


interface IContentItem {
    text: unknown,
    style: string,
    fillColor?: string,
    margin?: number[],
    bold?: boolean,
}



export const buildBodyContent = <T>({
                                        data,
                                        columns,
                                    }: {
    data: T[], columns: IColumnItem<T>[]
}): IContentItem[][] => {
    const body: IContentItem[][] = [];
    if (data?.length) {
        data.forEach((dataItem) => {
            const row: IContentItem[] = []
            columns.forEach((column, index) => {
                const id = column['id'];
                const style = styleColumnCb(column,)
                row.push({
                    bold: true,
                    style,
                    text: dataItem[id as keyof unknown] || '-',
                    margin: [],
                })
            })
            body.push(row)

        })
    }
    return body
}